::ng-deep particle-data-mapping-orbitax-field-cell-viewer{display:flex;width:100%}::ng-deep particle-data-mapping-orbitax-field-cell-viewer .ellipse{overflow:hidden;text-overflow:ellipsis;display:inline-block;white-space:nowrap}
/*# sourceMappingURL=data-mapping-orbitax-field-cell-viewer.component-IFNY27QE.css.map */
